import { ConfigStore } from "../../store/modules/config";
import { CatalogStore } from "../../store/modules/catalog";
import { CatalogsTypes } from "../../data/enums/catalogsTypes";
import { TemplateData } from "../../data/templateData";
import { TemplatesStore } from "../../store/modules/templates";
import { getModule } from "vuex-module-decorators";
import ICatalogService from "../../services/catalog/ICatalogService";
import { container } from "@/inversify.config";
import { ChargeData } from "../../data/chargeData";
import { getCookie } from '../../utilities/cookieHelper';
import { DiTokens } from "../../services/diTokens";
import { Region } from '../../data/regionsData';
import { searchCatalogById } from '../../utilities/index';
import IAlertService from "../../services/alert/IAlertService";
import i18n from "@/i18n";
import { CatalogData } from "../../data/catalogData";
import Vue from "vue";

/**
 *  Класс для компоненты каталога.
 */
export class CatalogVue extends Vue {

  /**
 * Сервис каталога
 * @returns {ICatalogService}
 */
  get catalogService(): ICatalogService {
    return container.get<ICatalogService>(DiTokens.CatalogService);
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище шаблонов
 * @returns {TemplatesStore}
 */
  get templatesStore(): TemplatesStore {
    return getModule(TemplatesStore, this.$store);
  }

  /**
 * Хранилище каталога
 * @returns {CatalogStore}
 */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  /**
 * Признак ЖКХ(ку)
 * @returns {boolean} - признак того выбран ли каталог ЖКХ.
 */
  get isHcs(): boolean {
    return (
      !!this.selectedCatalog &&
      (this.selectedCatalog.Caption.toUpperCase().includes(
        "ЖКХ"
      ) ||
        this.selectedCatalog.Caption.toUpperCase().includes(
          "ЖКУ"
        ) ||
        this.selectedCatalog.Caption.toUpperCase().includes(
          "КОММУНАЛЬН"
        ))
    );
  }

  /**
 * Ограничение по количеству показываемых шаблонов
 * @returns {Array<TemplateData>} - массив шаблонов с ограничением в 6, если это возможно.
 */
  get temlatesShow(): Array<TemplateData> {
    if (this.simpleTemplates.length > 7) return this.simpleTemplates.slice(0, 6);
    return this.simpleTemplates;
  }

  /** выбранный каталог */
  selectedCatalog: any = null;

  /** родительский каталог */
  parentCatalog: Array<any> = [];

  /** признак активного поиска */
  searchActive: boolean = false;

  /** признак открытыия фильтров */
  filtersWrap: boolean = false;

  /** массив регионов */
  regions: Array<Region> = [];

  /** поисковой запрос */
  query: string = '';

  /** выбранный регион для поиска */
  city: string = '';

  /**
 * Колличество начислений
 * @returns {string} - Колличество начислений
 */
  get chargesCount(): string {
    return (this.catalogStore.charges.filter((charge: ChargeData) => !charge.Hidden).length || 0).toString();
  }

  /**
 * Признак загрузки начислений
 * @returns {boolean} - Признак загрузки начислений
 */
  get chargesLoading(): boolean {
    return this.catalogStore.chargesLoading;
  }

  /**
 * Признак загрузки каталога
 * @returns {boolean} - Признак загрузки каталога
 */
  get loading(): boolean {
    return this.catalogStore.catalogLoading;
  }

  /**
 * Выбранный каталог
 * @returns {Array<any>} - массив элементов каталога
 */
  get catalog(): Array<any> {
    if (!this.selectedCatalog) return this.catalogStore.catalog.Childrens;
    return [this.selectedCatalog];
  }

  /**
 * Выбранный каталог для пополнения
 * @returns {Array<any>} - массив элементов каталога
 */
  get upToContractCatalog() {
    return [
      searchCatalogById(this.catalogStore.catalog, this.configStore.apiData.OperationCodeOfToContract)
    ];
  }

  /**
 * Простые шаблоны
 * @returns {Array<TemplateData>} - массив шаблонов
 */
  get simpleTemplates(): Array<TemplateData> {
    return this.templatesStore.simpleTemplates.filter(
      (temp: TemplateData) => temp.IsActive
    );
  }

  /** загрузка начислений */
  async getCharges(): Promise<void> {
    await this.catalogStore.fetchCharges(getCookie('isAllChargesVisible') == 'true');
  }

  /** переход на страницу начислений */
  toCharges(): void {
    this.$router.push("/charges");
  }

  /** открыть шаблон */
  openTemplate(template: TemplateData): void {
    if (template.IsActive) {
      this.$router.push("operation/1/" + template.Id);
    }
  }

  /** изменение поискового запроса */
  setQuery(e: any) {
    this.query = e.query;
  }

  /** поиск каталога */
  async searchCatalog(e: any) {
    this.selectedCatalog = null;
    this.searchActive = true;
    this.parentCatalog = [];
    if (e.query === null && e.city === null) {
      this.searchActive = false;
      await this.catalogStore.fetchCatalog(0);
    } else {
      if (!e.city && !this.city && e.query.length < 3) {
        this.alertService.warning(i18n.t('common.errors.minimumSymbols', {symbs: 3}).toString());
        return;
      }
      await this.catalogStore.searchCatalog({ query: e.query, city: e.city ? e.city : this.city });
    }
  }

  /** очитска поиска и каталога */
  clearCatalog() {
    this.city = '';
    this.query = '';
    this.searchCatalog({ query: null, city: null });
  }

  /** переход к каталогу или категории */
  async toCategory(oper: CatalogData) {
    if (oper.IsFolder) {
      this.parentCatalog.push(this.catalog);
      this.selectedCatalog = await this.catalogStore.fetchCatalog(oper.Id);
    } else if (oper.CatalogType == CatalogsTypes.ExtOperation) {
        const catId =
          !oper.Id || isNaN(oper.Id)
            ? this.configStore.apiData.OperationCodeOfToExt
            : oper.Id;

        const initData: Array<string> = [];

        for (const i in oper.AdditionalInitData) {
          initData.push(`${i}=${oper.AdditionalInitData[i]}`);
        }
        this.alertService.info(i18n.t("main.catalog.hcsPaymentWarning").toString(), false);
        this.$router.push(`operation/0/${catId}?${initData.join("&")}`);
        await this.catalogStore.fetchCatalog(0);
    } else {
      const initDataQuery = [];
        for (const i in this.$route.query) {
          initDataQuery.push(`${i}=${encodeURIComponent(
            this.$route.query[i]
          )}`);
        }
        const isApplication = oper.IsClientRequest || oper.IsProduct;

        this.$router.push("operation/0/" + oper.Id + `?${initDataQuery.length ? initDataQuery.join('&') + '&' : ''}_categoryName=${oper.Caption ? encodeURIComponent(oper.Caption) : ""}&_categoryImg=${oper.Picture ? encodeURIComponent(oper.Picture) : ""}${isApplication ? "&_application=1" : ""}${oper.Config === "FindAndPayGisGmp" ? `&_config=${oper.Config}` : ""}`);
    }
  }

  /** признак страницы каталога */
  get isCatalogPage(): boolean {
    return this.$route.name == 'Payments';
  }

  /** признак отображения категории */
  isAvailableCategory(category: any): boolean {
    if ((!category.IsClientRequest && this.isCatalogPage) || (category.IsClientRequest && !this.isCatalogPage))
      return true;
    return false;
  }

  /** признак пустого каталога */
  get isCatalogEmpty(): boolean {
    return this.catalog.filter((category: any) => this.isAvailableCategory(category)).length === 0;
  }

  /** вернуться назад */
  async back() {
    if (this.selectedCatalog) {
      this.selectedCatalog = this.parentCatalog[
        this.parentCatalog.length - 1
      ][0];
      this.parentCatalog.pop();
      if (this.parentCatalog.length === 0) this.selectedCatalog = null;
    } else if (this.searchActive) {
      await this.catalogStore.fetchCatalog(0);
      this.searchActive = false;
    } else {
      this.$router.go(-1);
    }
  }
}
